import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { FC, SyntheticEvent } from "react";

import { WishlistModel } from "@/redux/modules/api/data/wishlist/@types/wishlist.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

interface WishlistButtonProps {
    sku: string;
    wishlists: WishlistModel[];
    addToWishlist?: () => void;
    removeFromWishlist?: () => void;
    label?: (isProductInWishlist: boolean) => string;
    labelClassName?: string;
    className?: string;
    iconSize?: string;
    disabled?: boolean;
}

const Wishlist: FC<WishlistButtonProps> = ({
    addToWishlist = () => null,
    removeFromWishlist = () => null,
    sku,
    wishlists,
    label,
    labelClassName,
    className,
    iconSize = "la-lg",
    disabled = false
}) => {
    const { t } = useGranite();

    const isProductInWishlist = wishlists.some((wishlist) =>
        wishlist.products.some((product) => product.sku === sku)
    );

    const handleOnButtonClick = (event: SyntheticEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();

        isProductInWishlist ? removeFromWishlist() : addToWishlist();
    };

    return (
        <Button
            className={className}
            color="link"
            onClick={handleOnButtonClick}
            disabled={disabled}
            type="button"
            aria-label={
                isProductInWishlist
                    ? t("accessibility.wishlistButton.remove")
                    : t("accessibility.wishlistButton.add")
            }
        >
            <i
                className={cn("la-heart", iconSize, {
                    lar: !isProductInWishlist,
                    las: isProductInWishlist
                })}
            ></i>
            {label && (
                <span className={cn("ml-1", labelClassName)}>
                    {label(isProductInWishlist)}
                </span>
            )}
        </Button>
    );
};

export default Wishlist;
